import { render, staticRenderFns } from "./users.vue?vue&type=template&id=247bc239&scoped=true&lang=pug"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247bc239",
  null
  
)

export default component.exports